import { createContext, useCallback, useContext, useMemo, useRef, useState } from "react";

const SessionContext = createContext(null);

export const SessionProvider = ({ children }) => {
  const [live, setLive] = useState(false);
  const stopRef = useRef(null);
  const registerStop = useCallback((stop) => { stopRef.current = stop; }, []);
  const endSession = useCallback(() => { stopRef.current?.("manual"); }, []);
  const value = useMemo(
    () => ({ live, setLive, registerStop, endSession }),
    [live, registerStop, endSession]
  );
  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
};

export const useSession = () => useContext(SessionContext);